import { render, staticRenderFns } from "./dialogConformDelete.vue?vue&type=template&id=cf4f0808&"
import script from "./dialogConformDelete.vue?vue&type=script&lang=js&"
export * from "./dialogConformDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports